import ToastificationContent from "@core/components/toastification/ToastificationContent"
import { createToastInterface } from "vue-toastification"

export default {
  data() {
    return {
      contractLabel: "NTDC",
      contractIdLabel: "NTDC ID",
    }
  },
  methods: {
    toastError(message) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: message,
            icon: "XIcon",
            variant: "danger",
          },
        },
        {
          toastClassName: "toast-error",
        }
      )
    },

    toastSuccess(message) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: message,
            icon: "CheckIcon",
            variant: "success",
          },
        },
        {
          toastClassName: "toast-success",
        }
      )
    },

    toastWarning(message) {
      this.$toast(
        {
          component: ToastificationContent,
          props: {
            title: message,
            icon: "AlertCircleIcon",
            variant: "warning",
          },
        },
        {
          toastClassName: "toast-warning",
        }
      )
    },

    // Loading-custom
    showLoading(isEnable) {
      const body = document.getElementsByTagName("BODY")[0]
      const appLoading = document.getElementById("loading-bg")
      if (isEnable) {
        body.style.overflow = "hidden"
        appLoading.style.display = "block"
        appLoading.style.zIndex = "10000"
      } else {
        body.style.overflow = "auto"
        appLoading.style.zIndex = "0"
        appLoading.style.display = "none"
      }
    },
  },
}

const toastInterface = createToastInterface({
  hideProgressBar: true,
  closeOnClick: false,
  closeButton: false,
  icon: false,
  timeout: 3000,
  transition: "Vue-Toastification__fade",
})

export const toast = {
  error: (message) => {
    toastInterface(
      {
        component: ToastificationContent,
        props: {
          title: message,
          icon: "XIcon",
          variant: "danger",
        },
      },
      {
        toastClassName: "toast-error",
      }
    )
  },
}
